<template>
  <div class="weather-sec" v-if="eventsForWeather.weatherData">
    <div
      class="weather-content"
      v-for="(
        dataItem, index
      ) in eventsForWeather.weatherData[0].validTimeLocal.slice(1)"
      :key="index"
    >
      <div class="weather-date">{{ dataItem | formatDateWeather }}</div>
      <img
        :src="
          iconUrl +
          eventsForWeather.weatherData[0].iconCode[(index + 1) * 2] +
          '.svg'
        "
        alt=""
      />
      <div class="tempr">
        <p class="high">
          {{ eventsForWeather.weatherData[0].temperatureMax[index + 1]
          }}<sup><span class="small-symbol">&deg;F</span></sup>
        </p>
        <p class="low">
          {{ eventsForWeather.weatherData[0].temperatureMin[index + 1]
          }}<sup><span class="small-symbol">&deg;F</span></sup>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Weather",
  props: {
    eventsForWeather: Object,
  },
  data() {
    return {
      iconUrl: "https://www.wunderground.com/static/i/c/v4/",
    };
  },
};
</script>

<style>
</style>